"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AskDataOptionNames = void 0;
var AskDataOptionNames;
(function (AskDataOptionNames) {
    AskDataOptionNames["token"] = "token";
    AskDataOptionNames["origin"] = "origin";
    AskDataOptionNames["showEmbed"] = "showEmbed";
    AskDataOptionNames["showPin"] = "showPin";
    AskDataOptionNames["showSave"] = "showSave";
    AskDataOptionNames["showShare"] = "showShare";
    AskDataOptionNames["debug"] = ":jsdebug";
    AskDataOptionNames["ApiID"] = ":apiID";
    AskDataOptionNames["ApiExternalVersion"] = ":apiExternalVersion";
    AskDataOptionNames["ApiInternalVersion"] = ":apiInternalVersion";
    AskDataOptionNames["AskDataWebComponent"] = ":askDataWebComponent";
})(AskDataOptionNames || (exports.AskDataOptionNames = AskDataOptionNames = {}));
//# sourceMappingURL=AskDataInterface.js.map